import AboutMe from "../components/aboutMe";
import ContactMe from "../components/contactMe";
import HomeBanner from "../components/HomeBanner";
import useLoader from "../hooks/useLoader";

function InitialPage() {
  const loading = useLoader();

  return (
    <main>
        <HomeBanner loading={loading}/>
        
        {
          !loading && <>
            <AboutMe />
            <ContactMe />
          </>
        }
    </main>
  );
}

export default InitialPage;
